// extracted by mini-css-extract-plugin
module.exports = {"error":"_error_error__6Oowu","error__heading":"_error_error__heading__eAR8o","error__copy":"_error_error__copy__x9ftR"};